import Vue from 'vue'
import vExport from './v-export.js'
export default function ({ app, router, urlPath, store }) {
    Vue.directive('export', {
        bind: function (el, binding, node) {
            const _uid = node.componentInstance ? node.componentInstance['_uid'] : node.context['_uid']
            vExport.data[_uid] = { el, binding, node }
            function download() {
                vExport.download(_uid)
            }
            el.download = download
            el.addEventListener('click', download)
        },
        update: function (el, binding, node) {
            const _uid = node.componentInstance ? node.componentInstance['_uid'] : node.context['_uid']
            vExport.data[_uid] = { el, binding, node }
        },
        unbind(el, binding, node) {
            const _uid = node.componentInstance ? node.componentInstance['_uid'] : node.context['_uid']
            vExport.data[_uid] = {}
            el.removeEventListener('click', el.download)
        },
    })
    Vue.directive('down', {
        inserted: (el, binding) => {
            el.addEventListener('click', () => {
                if (!binding.value) return
                if (typeof binding.value == 'object') {
                    binding.value.forEach(item => {
                        let link = document.createElement('a')
                        let url = ''
                        if (item.indexOf('http') != -1 || item.indexOf('https') != -1) {
                            url = item
                        } else {
                            url = app.axios.defaults.baseURL + item + '?token=' + store.state.token
                        }
                        link.href = url
                        link.setAttribute('target', '_blank')
                        link.download = url.split('/')[url.split('/').length - 1]
                        document.body.appendChild(link)
                        link.click()
                        document.body.removeChild(link)
                    })
                } else {
                    let link = document.createElement('a')
                    let url = ''
                    if (binding.value.indexOf('http') != -1 || binding.value.indexOf('https') != -1) {
                        url = binding.value
                    } else {
                        url = app.axios.defaults.baseURL + binding.value + '?token=' + store.state.token
                    }
                    link.href = url
                    link.setAttribute('target', '_blank')
                    document.body.appendChild(link)
                    link.click()
                    document.body.removeChild(link)
                }

                // 这里是将url转成blob地址，
                // 	fetch(url, { method: "GET", mode: "cors" })
                // 		.then((res) => res.blob())
                // 		.then((blob) => {
                // 			// 将链接地址字符内容转变成blob地址
                // 			link.href = URL.createObjectURL(blob);
                // 			link.download =
                // 				url.split("/")[url.split("/").length - 1];
                // 			document.body.appendChild(link);
                // 			link.click();
                // 		});
            })
        },
    })
    Vue.directive('autocomplete-scroll', {
        bind(el, binding, vnode) {
            // 此处为了简单，直接判断触底了
            function handleScroll(e) {
                let isBottom = e.target.clientHeight + e.target.scrollTop == e.target.scrollHeight
                if (isBottom && !vnode.context.loading) {
                    binding.value()
                }
            }
            // 监听滚动
            let wrapDom = el.querySelector('.el-autocomplete-suggestion__wrap') || el.querySelector('.el-select-dropdown__wrap')
            el.__handleScroll__ = handleScroll
            el.__wrapDom__ = wrapDom
            wrapDom.addEventListener('scroll', handleScroll, false)
        },
        unbind(el, binding, vnode) {
            // 解除事件监听
            el.__wrapDom__.removeEventListener('scroll', el.__handleScroll__, false)
        },
    })
    Vue.directive('float', function (el, value, node) {
        const params = value.value || 2
        if (node.data.model.value) {
            let str = node.data.model.value.toString()

            const reg = eval(`/^\\D*(\\d*(?:\\.\\d{0,${params}})?).*$/g`)
            str = str.replace(reg, '$1')
            if (str.length >= 2 && str[0] == '0' && str[1] != '.') {
                str = str - 0
            }
            node.data.model.callback(str)
        }
    })
}
